module.exports = __webpack_public_path__ + "img/chat-icon.13c3b78f.svg";